import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  top: {
    Home: '格朗首页',
    About: '关于格朗',
    Company_Profile: '公司简介',
    Corporate_philosophy: '企业理念',
    Corporate_Honors: '企业荣誉',
    Company_Scenarios: '公司场景',
    Products: '产品中心',
    News: '新闻动态',
    Service: '服务支持',
    Contact: '联系我们',
    Cnlang: '中文',
    Enlang: '英语'
  },
  home: {
    WhyChooseUs: '为什么选择我们？',
    LatestNews: '最新动态',
    PurchaseNow: '立即购买',
    SomeofOurClients: '公司客户',
    ReadMore: '查看更多'
  },
  footer: {
    Phone: '电话',
    EMail: '邮箱',
    Web: '网站',
    Address: '地址'
  },
  common: {
    CompanyName: '温岭格朗智能科技有限公司',
    Glang: '格朗',
    CompanyAddress: '浙江省温岭市东部新区孵化园A区1号楼',
    CurrentLocation: '您当前位置',
    ReadMore: '阅读全文',
    LearnMore: '了解更多',
    ProductsDetail: '产品详情',
    NewsDetail: '新闻详情',
    ServiceDetail: '服务详情'
  },
  contact: {
    LeaveAMessage: '我要留言',
    Name: '您的名字 (必填)',
    Phone: '您的电话（必填）',
    EMail: '您的邮箱 (必填)',
    MessageContent: '您的留言',
    Send: '发送'
  },
  products: {
    AllProducts: '全部产品',
    Next: '下一个产品',
    Prev: '上一个产品',
    ProductOverview: '产品概述',
    UseCondition: '使用条件',
    ModelDescription: '型号说明',
    TechnicalParameter: '技术参数',
    PerformanceCurve: '性能曲线',
    ProductDetails: '产品详情',
    RelatedProducts: '相关产品',
    ModelName: '基本参数',
    Message: '留言'
  },
  ...zhLocale
}

export default cn
